<template>
  <FormWrapper :handleSubmit="submit" :loading="loading">
    <template #default>
      <b-row class="margin-0">
        <b-col cols="12" class="padding-0">
          <Input
            :title="$lang.register_link_caption"
            :label="$lang.register_link_caption"
            :placeholder="$lang.register_link_caption"
            :value="form.registerLinkCaption"
            name="registerLinkCaption"
            id="registerLinkCaption"
            type="text"
            :vuelidateObj="$v.form.registerLinkCaption"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </b-col>
        <b-col cols="12" class="padding-0">
          <Switchbox
            :label="$lang.showRegisterLink"
            :value="form.showRegisterLink"
            name="showRegisterLink"
            boxClass="flex-between"
            @input="input"
          />
        </b-col>
        <b-col cols="12" class="padding-0">
          <TextEditor
            :title="`${$lang.registerCondition} (${$lang.optional})`"
            :label="$lang.registerCondition"
            :placeholder="$lang.registerCondition"
            :value="form.registerCondition"
            name="registerCondition"
            id="registerCondition"
            :vuelidateObj="$v.form.registerCondition"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </b-col>
        <b-col cols="12" class="padding-0">
          <Dropdown
            :title="$lang.registerMethod"
            :label="$lang.registerMethod"
            :placeholder="$lang.registerMethod"
            :value="form.registerType"
            name="registerType"
            id="registerType"
            :vuelidateObj="$v.form.registerType"
            :options="registerTypeOptions"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </b-col>
        <b-col v-if="isRegisterTypeWithCode" cols="12" class="padding-0">
          <Input
            :title="$lang.linkRegisterCodeCaption"
            :label="$lang.linkRegisterCodeCaption"
            :placeholder="$lang.linkRegisterCodeCaption"
            :value="form.linkRegisterCodeCaption"
            name="linkRegisterCodeCaption"
            id="linkRegisterCodeCaption"
            type="text"
            :vuelidateObj="$v.form.linkRegisterCodeCaption"
            @input="input"
            @focus="resetValidation"
            @blur="checkValidation"
          />
        </b-col>
        <b-col v-if="isRegisterTypeWithCode" cols="12" class="padding-0">
          <Switchbox
            :label="$lang.linkCheckNationalCode"
            :value="form.linkCheckNationalCode"
            name="linkCheckNationalCode"
            boxClass="flex-between"
            @input="input"
          />
        </b-col>
        <b-col
          v-if="isRegisterTypeWithCode"
          cols="12"
          class="padding-0 margin-bottom-16"
        >
          <RegisterCodes />
        </b-col>
      </b-row>
    </template>
  </FormWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  FormWrapper,
  Dropdown,
  Input,
  Switchbox,
  TextEditor,
} from "@/components/re-design/forms";
import RegisterCodes from "../register-code/RegisterCodes.vue";
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { editRegisterTypeTerm } from "@/modules/profile/services";
export default {
  mixins: [inputMixin],
  inject: ["TERM_CODE", "TERM_DATA"],
  components: {
    FormWrapper,
    Dropdown,
    Input,
    Switchbox,
    TextEditor,
    RegisterCodes,
  },
  validations() {
    return {
      form: {
        registerLinkCaption: { required },
        registerCondition: {},
        registerType: { required },
        linkRegisterCodeCaption: {
          required: requiredIf(() => this.isRegisterTypeWithCode),
        },
      },
    };
  },
  data() {
    return {
      form: {
        registerLinkCaption: null,
        showRegisterLink: false,
        registerCondition: null,
        registerType: null,
        linkRegisterCodeCaption: null,
        linkCheckNationalCode: null,
      },
      loading: false,
      registerTypeOptions: [
        { id: 0, caption: "ثبت نام بدون کد" },
        { id: 1, caption: "ثبت نام با کد" },
      ],
    };
  },
  computed: {
    isRegisterTypeWithCode() {
      return pathOr(null, ["registerType", "id"], this.form) === 1;
    },
  },
  watch: {
    TERM_DATA: {
      immediate: true,
      handler(data) {
        this.fetchData(data);
      },
    },
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const {
          linkRegisterCodeCaption,
          showRegisterLink,
          registerCondition,
          registerType,
          registerLinkCaption,
          linkCheckNationalCode,
        } = this.form;
        const payloadData = {
          termCode: this.TERM_CODE,
          registerLinkCaption,
          showRegisterLink: Number(showRegisterLink),
          registerCondition,
          registerType: pathOr(null, ["id"], registerType),
          linkRegisterCodeCaption,
          linkCheckNationalCode: Number(linkCheckNationalCode),
        };
        const response = await editRegisterTypeTerm(payloadData);
        const { message } = response;
        this.$notify.success(message);
        this.$emit("getTermData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    fetchData(data) {
      this.form.showRegisterLink = pathOr(false, ["link_show"], data);
      const registerTypeId = +pathOr(false, ["link_register_by_code"], data);
      this.form.registerType = this.registerTypeOptions.find(
        (item) => item.id === registerTypeId
      );
      this.form.registerLinkCaption = pathOr(null, ["link_caption"], data);
      this.form.registerCondition = pathOr(null, ["register_condition"], data);
      this.form.linkRegisterCodeCaption = pathOr(
        null,
        ["link_register_code_caption"],
        data
      );
      this.form.linkCheckNationalCode = pathOr(
        false,
        ["link_check_national_code"],
        data
      );
    },
  },
};
</script>
